module.exports = __webpack_public_path__ + "static/img/batp.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/batp.png
// module id = kiKz
// module chunks = 29